import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSidebar } from '../SidebarContext';
import Sidebar from './SideBar';
import Slider2Modal from './Slider2Modal';
import LocationAdvantageModal from './LocationAdvantageModal';

const LocationAdvantageUpdated = () => {
    const { isSidebarOpen } = useSidebar();

    const [searchQuery, setSearchQuery] = useState('');
    const [amenities, setAmenities] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [inputValue, setInputValue] = useState('');
    const [inputValuelink, setInputValuelink] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);

    const [editIndex, setEditIndex] = useState(null);
    const [editValue, setEditValue] = useState('');

    const itemsPerPage = 10;
    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;

    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const BASE_URL = "https://100real.xyz";

    useEffect(() => {
        fetchAmenities();
    }, []);

    const fetchAmenities = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/location/all/${isLoggedIn.user_id}`);
            setAmenities(response.data.reverse());
        } catch (error) {
            console.error('Error fetching location:', error);
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const filteredAmenities = amenities.filter((item) =>
        ['name', 'status'].some((key) =>
            String(item[key]).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const totalPages = Math.ceil(filteredAmenities.length / itemsPerPage);
    const currentData = filteredAmenities.slice(indexOfFirstItem, indexOfFirstItem + itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleInputChange = (event) => setInputValue(event.target.value);
    const handleInputChangeLink = (event) => setInputValuelink(event.target.value);
    const handleFileChange = (event) => setSelectedFile(event.target.files[0]);

    const handleAddAmenities = async () => {
        if (!inputValue.trim()) {
            toast.warning('Please enter location advantages');
            return;
        }

        const newAdvantages = inputValue.split(',').map((item) => item.trim()).filter((item) => item !== '');

        try {
            for (const adv of newAdvantages) {
                const dataToUpdate = {
                    name: adv,
                    status: 'active',
                    user_id: isLoggedIn.user_id
                };

                const response = await axios.post(`${BASE_URL}/location/igothousifyu`, dataToUpdate);
                if (response.status === 200) {

                }
            }

            toast.success('All Location Advantages Added');
            fetchAmenities(); // Refresh list
            setInputValue('');
            setIsModalOpen(false);
            setSelectedFile(null);
        } catch (error) {
            toast.error('Error adding one or more items');
            console.error('Error:', error);
        }
    };


    const handleEdit = (id) => {
        const amenity = amenities.find(item => item.id === id);
        if (amenity) {
            setEditIndex(id);   // Save ID instead of index
            setEditValue(amenity.name);
        }
    };

    const handleEditChange = (event) => {
        setEditValue(event.target.value);
    };

    const handleSaveEdit = async (index) => {
        const amenity = amenities.find(item => item.id === editIndex);
        if (!amenity) return;
        const dataToUpdate = { name: editValue, status: amenity.status };
        if (editValue === null || editValue === "") {
            toast.warning("Location  is required")
            return;
        }
        try {
            const response = await axios.put(`${BASE_URL}/location/change/${amenity.id}`, dataToUpdate);
            if (response.status === 200) {
                toast.success('Location Advantage updated');
                fetchAmenities();
                setEditIndex(null);
                setEditValue('');
            }
        } catch (error) {
            toast.error(error);
            console.error('Error updating location:', error.response.data || error.message);
        }
    };

    const handleDelete = async (id) => {

        try {
            const response = await axios.delete(`${BASE_URL}/location/${id}`);
            if (response.status === 200) {
                toast.success('Location Deleted');
                fetchAmenities();
            }
        } catch (error) {
            toast.error(error);
            console.error('Error deleting location:', error);
        }
    };

    const handleToggleStatus = async (id) => {
        const amenity = amenities.find(item => item.id === id); // 🔥 Find by ID
        if (!amenity) return;
        const updatedStatus = amenity.status === 'active' ? 'inactive' : 'active';

        try {
            const response = await axios.put(`${BASE_URL}/location/change/${amenity.id}`, { status: updatedStatus });
            if (response.status === 200) {
                toast.success('Location adavantage Status Updated');
                fetchAmenities();
            }
        } catch (error) {
            toast.error(error);
            console.error('Error toggling status:', error);
        }
    };

    return (
        <>
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Our Advantage</h1>
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Advantage
                    </button>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Advantage</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData && currentData.length > 0 ? (
                                currentData.map((amenity, index) => {
                                    const absoluteIndex = indexOfFirstItem + index;
                                    return (
                                        <tr key={amenity.id}>
                                            <td>
                                                {editIndex === amenity.id ? (
                                                    <input
                                                        type="text"
                                                        value={editValue}
                                                        onChange={handleEditChange}
                                                        className='oms-input-table-crm'
                                                    />
                                                ) : (
                                                    amenity.name
                                                )}
                                            </td>
                                            <td>
                                                <span className={amenity.status}>
                                                    {amenity.status.charAt(0).toUpperCase() + amenity.status.slice(1)}
                                                </span>
                                            </td>
                                            <td>
                                                {editIndex === amenity.id ? (
                                                    <button onClick={handleSaveEdit}> <i className="fa fa-save" /></button>
                                                ) : (
                                                    <>
                                                        <button onClick={() => handleToggleStatus(amenity.id)}>
                                                            <i className={`fa ${amenity.status === 'active' ? 'fa-toggle-on' : 'fa-toggle-off'}`} />
                                                        </button>
                                                        <button onClick={() => handleEdit(amenity.id)}>
                                                            <i className="fa fa-edit" />
                                                        </button>
                                                        <button onClick={() => handleDelete(amenity.id)}>
                                                            <i className="fa fa-trash" />
                                                        </button>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="3">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>

                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <LocationAdvantageModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                inputValue={inputValue}
                handleInputChange={handleInputChange}
                inputValuelink={inputValuelink}
                handleInputChangeLink={handleInputChangeLink}
                handleFileChange={handleFileChange}
                handleAddAmenities={handleAddAmenities}
            />
        </>
    );
};

export default LocationAdvantageUpdated;
